import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './styles.css';
function SubTabsWarehouses() {
  const location = useLocation();
  const isInventorySelected =
    location.pathname.startsWith("/warehouses/inventories") ||
    location.pathname.startsWith("/warehouses/dictionary-partnumbers-sapcodes");
  const isStockProcurementSelected =
    location.pathname.startsWith("/warehouses/stock-procurement") ||
    location.pathname.startsWith("/warehouses/purchases-upload");
  return (
    <div className="scrollable-container-app">
      <ul className="nav nav-tabs">
        <li className="nav-item" style={{ display: "flex", flexDirection: "column" }}>
          <NavLink to="/warehouses/inventories" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Inventory
          </NavLink>
          {isInventorySelected && (
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap" }}>
              <NavLink to="/warehouses/inventories-leo" className="nav-link" activeClassName="active"
              style={{ height: "28px", fontSize: "12px", textAlign: "left", paddingLeft: "12px", paddingRight: "8px", whiteSpace: "nowrap" }}>
                ↳ Import LEO
              </NavLink>
              <NavLink to="/warehouses/dictionary-partnumbers-sapcodes" className="nav-link" activeClassName="active"
              style={{ height: "28px", fontSize: "12px", textAlign: "left", paddingLeft: "8px", paddingRight: "12px", whiteSpace: "nowrap" }}>
                ↳ Dictionary Partnumbers
              </NavLink>
            </div>
          )}
        </li>
        <li className="nav-item">
          <NavLink to="/warehouses/outbound" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Outbound
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/warehouses/inbound" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Inbound
          </NavLink>
        </li>
        <li className="nav-item" style={{ display: "flex", flexDirection: "column" }}>
          <NavLink to="/warehouses/stock-procurement" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Purchases - Stock & Procurement
          </NavLink>
          {isStockProcurementSelected && (
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap" }}>
              <NavLink to="/warehouses/purchases-upload" className="nav-link" activeClassName="active"
              style={{ height: "28px", fontSize: "12px", textAlign: "left", paddingLeft: "12px", paddingRight: "12px", whiteSpace: "nowrap" }}>
                ↳ Import Purchases
              </NavLink>
            </div>
          )}
        </li>
        <li className="nav-item">
          <NavLink to="/warehouses/stock-report" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Stock report - Shortage
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/warehouses/purchases-podelay" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Purchases - poDelay
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/warehouses/transferts" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Transferts - Stock & Procurement
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/warehouses/transferts-podelay" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Transferts - poDelay
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/warehouses/warehouse-budget" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Warehouse Budget
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default SubTabsWarehouses;
